import { getSessionOrganizationId } from '../../shell/session/sessionOrganization';
import {
  mapWebSupplierRow,
  suppliersFromWebCacheOrNull,
  type SupplierFilterState,
  type SupplierRecord,
} from './suppliersRepoShared';
import { getCatalogRamSnapshotCache } from './catalogRamSnapshotCache';
/** Contar proveedores según filtro de estado */
export const countSuppliersLocal = async (
  filterState: SupplierFilterState = 'active',
  search?: string
): Promise<number> => {
  const org = await getSessionOrganizationId();
  if (!org) return 0;

  // ADR-017 Fase 4: SQLite local eliminado — leer de catalogRamSnapshotCache.
  const cached = suppliersFromWebCacheOrNull(org, filterState, search);
  return cached !== null ? cached.length : 0;
};

/** Listar proveedores paginados según filtro de estado */
export const listSuppliersLocalPaged = async ({
  filterState = 'active',
  search,
  limit,
  offset = 0,
}: {
  filterState?: SupplierFilterState;
  search?: string;
  limit?: number;
  offset?: number;
}): Promise<SupplierRecord[]> => {
  const org = await getSessionOrganizationId();
  if (!org) return [];

  // ADR-017 Fase 4: SQLite local eliminado — leer de catalogRamSnapshotCache.
  return suppliersFromWebCacheOrNull(org, filterState, search, limit, offset) ?? [];
};

/** Listado completo de proveedores activos e inactivos para la pantalla de administración. */
export const listSuppliersLocal = async (): Promise<SupplierRecord[]> => {
  const org = await getSessionOrganizationId();
  if (!org) return [];
  // ADR-017 Fase 4: SQLite local eliminado — leer de catalogRamSnapshotCache.
  return suppliersFromWebCacheOrNull(org, 'all') ?? [];
};

export const listActiveSuppliersLocal = async (): Promise<
  Array<{ id: string; name: string; taxId: string | null }>
> => {
  const org = await getSessionOrganizationId();
  if (!org) return [];

  const fromCache = suppliersFromWebCacheOrNull(org, 'active');
  if (fromCache !== null) {
    // taxId: pre-carga del CUIT en el comprobante fiscal de gastos (Libro IVA compras).
    return fromCache.map((supplier) => ({
      id: supplier.id,
      name: supplier.name,
      taxId: supplier.taxId ?? null,
    }));
  }
  return [];
};

/** Obtener detalles completos de un proveedor por ID */
export const getSupplierByIdLocal = async (supplierId: string): Promise<SupplierRecord | null> => {
  const cached = getCatalogRamSnapshotCache()?.suppliers.find((s) => String(s.id) === supplierId);
        return cached ? mapWebSupplierRow(cached) : null;
};
